import React from 'react';
import {
    TextField,
    Card,
    CardContent,
    Typography
} from '@mui/material';

const ManualUrlComponent = ({
    link,
    onLinkChange,
    disabled = false,
    errors = {}
}) => {
    return (
        <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                    Manual URL Configuration
                </Typography>
                <TextField
                    fullWidth
                    label="Video URL"
                    value={link}
                    onChange={(e) => onLinkChange(e.target.value)}
                    disabled={disabled}
                    required
                    error={!!errors.link}
                    helperText={errors.link || "Enter the direct URL to your video stream"}
                    size="small"
                    placeholder="rtsp://example.com/stream or http://example.com/video.mp4"
                />
            </CardContent>
        </Card>
    );
};

export default ManualUrlComponent;
